import { PortfolioEnterpriseGroupResult } from '@mews-commander/data-access';
import { LocalizedText, UseDialogActionReturn } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Dialog } from '@optimus-web/core';

interface DeletePropertiesDialogProps {
    propertyGroup: PortfolioEnterpriseGroupResult;
    propertyCount: number;
    deleteAction: UseDialogActionReturn;
    loading?: boolean;
}

export const DeletePropertiesDialog = ({
    deleteAction,
    loading,
    propertyGroup,
    propertyCount,
}: DeletePropertiesDialogProps) => (
    <Dialog
        title={
            <LocalizedText
                textKey={TextKey.RemovePropertiesFromPropertyGroupDialogTitle}
                substitutes={{ count: propertyCount }}
            />
        }
        actions={[
            {
                children: <LocalizedText textKey={TextKey.Cancel} />,
                onClick: deleteAction.handlers.handleCancel,
                variant: 'tertiary',
                size: 'medium',
                type: 'button',
            },
            {
                children: <LocalizedText textKey={TextKey.Delete} />,
                onClick: deleteAction.handlers.handleConfirm,
                variant: 'destructive',
                size: 'medium',
                type: 'submit',
            },
        ]}
        active
        loading={deleteAction.states.isProcessing || loading}
        onClose={deleteAction.handlers.handleCancel}
    >
        <LocalizedText
            textKey={TextKey.RemovePropertiesFromPropertyGroupDialogContent}
            substitutes={{ propertyGroupName: propertyGroup.name }}
        />
    </Dialog>
);
